import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/sthony/Documents/Sthony/ailumix-web-current/apps/web/src/app/strategy/[key]/StrategyDetail.tsx");
